<template>
	<!-- <div v-if="$tera.project.schematic">
		<p>
			{{
				selectRandom([
					"The following diagram shows the flow of participants through the trial:",
					"The participants will take part in the trial according to the following diagram:",
					"The participants will make their way through the trial following the diagram shown:",
					"The flow of participants through the trial will follow the diagram shown below:"
				])
			}}
		</p>
		<p>*INSERT SCHEMATIC DIAGRAM HERE*</p>
	</div> -->
	<div>
		<p>
			{{ selectRandom(["The trial will run for ", "The trial duration is ", "This trial is set to run for"]) }}
			{{
				$tera.project.TrialWizard.trialTimeline == `other`
							? $tera.project.TrialWizard.trialTimelineOther
							: $tera.project.TrialWizard.trialTimeline
			}}
			{{ selectRandom([" and outcomes will be assessed at ", " with outcomes assessed at ", ", with assessments conducted at " ]) }}
			{{ $tera.project.TrialWizard.ispreBaseline ? "pre-baseline," : ""}} baseline and every
			{{ $tera.project.TrialWizard.trialTimeFrequency == `other`
					? $tera.project.TrialWizard.trialTimeFrequencyOther
					: $tera.project.TrialWizard.trialTimeFrequency
			}}.
		</p>
		<!-- <p>
			{{
				selectRandom([
					`The trial will run for ${$tera.project.TrialWizard.trialTimeline == `other`
						? $tera.project.TrialWizard.trialTimelineOther
						: $tera.project.TrialWizard.trialTimeline
					} outcomes will be assessed at
			${$tera.project.TrialWizard.ispreBaseline ? "pre-baseline," : ""
					} baseline and every
			${$tera.project.TrialWizard.trialTimeFrequency == `other`
						? $tera.project.TrialWizard.trialTimeFrequencyOther
						: $tera.project.TrialWizard.trialTimeFrequency
					}.`
				])
			}}
		</p> -->
		<p v-for="sentence in processedSentences" :key="sentence">{{ sentence }}</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputParticipantTimeline",
	mixins: [OutputMixin],
	computed: {
		processedSentences() {
			let sentences = [];
			this.$tera.project.TrialWizard.timelineTable.rows.forEach(row => {
				let outcomeName = row.Outcomes;
				let timePoints = [];

				this.$tera.project.TrialWizard.timelineTable.headers
					.slice(1)
					.forEach(header => {
						let timePoint = header.label;
						if (row[timePoint] === "") {
							timePoints.push(timePoint);
						}
					});

				if (timePoints.length > 0) {
					let timeString = timePoints.slice(0, -1).join(", ");
					if (timePoints.length > 1) {
						timeString += " and " + timePoints.slice(-1);
					} else {
						timeString = timePoints[0];
					}
					let sentence = `For ${outcomeName}, assessment is done at ${timeString}.`;
					sentences.push(sentence);
				}
			});

			return sentences;
		}
	}
};
</script>
